import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import Button from "@mui/material/Button";
import PackageFinder from "./PackageFinder";
import { FormGroup, FormControlLabel } from "@mui/material";

const OperatorTabs = ({
  packagesDict,
  setPackageFormData,
  packageFormData,
}) => {
  const [operators, setOperators] = useState({
    luxmed: false,
    medicover: false,
    pzu: false,
    enel: false,
    dentist: false,
  });
  const [value, setValue] = useState(null);

  const parseMeds = () => {
    let arr = [];
    packagesDict[0].package_serializer.map((entry) => {
      if (entry.type === 1) {
        arr.push(entry);
      }
    });
    return arr;
  };

  const parseDents = () => {
    let arr = [];
    packagesDict[0].package_serializer.map((entry) => {
      if (entry.type === 2) {
        arr.push(entry);
      }
    });
    return arr;
  };

  const parseDict = () => {
    let arr = [];
    let newArr = arr.concat(
      operators.luxmed ? parseMeds() : [],
      operators.medicover ? packagesDict[1].package_serializer : [],
      operators.pzu ? packagesDict[2].package_serializer : [],
      operators.enel ? packagesDict[3].package_serializer : [],
      operators.dentist ? parseDents() : []
    );
    return newArr;
  };

  const resetSelection = () => {
    setValue(null);
    setPackageFormData({ ...packageFormData, package: "" });
  };

  const handleChange = (event) => {
    resetSelection();
    setOperators({
      ...operators,
      [event.target.name]: event.target.checked,
    });
  };

  const handleSelectAllClick = () => {
    resetSelection();
    setOperators({
      luxmed: true,
      medicover: true,
      pzu: true,
      enel: true,
      dentist: true,
    });
  };

  useEffect(() => {
    setPackageFormData({ ...packageFormData, package: "" });
  }, [operators]);

  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{
          borderBottom: 1,
          borderColor: "divider",
          display: "flex",
          flexDirection: "column",
          pb: 2,
        }}
      >
        <Box sx={{ mb: 1.5 }}>
          <Button
            variant="outlined"
            size="small"
            onClick={handleSelectAllClick}
          >
            Zaznacz wszystko
          </Button>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            mb: 1,
          }}
        >
          <FormGroup sx={{ display: "flex", flexDirection: "row" }}>
            <FormControlLabel
              label="LUXMED"
              control={
                <Checkbox
                  name="luxmed"
                  checked={operators.luxmed}
                  onChange={handleChange}
                />
              }
            />

            <FormControlLabel
              label="MEDICOVER"
              control={
                <Checkbox
                  name="medicover"
                  checked={operators.medicover}
                  onChange={handleChange}
                />
              }
            />
            <FormControlLabel
              label="PZU ZDROWIE"
              control={
                <Checkbox
                  name="pzu"
                  checked={operators.pzu}
                  onChange={handleChange}
                />
              }
            />
            <FormControlLabel
              label="ENEL-MED"
              control={
                <Checkbox
                  name="enel"
                  checked={operators.enel}
                  onChange={handleChange}
                />
              }
            />
            <FormControlLabel
              label="Stomatologia"
              control={
                <Checkbox
                  name="dentist"
                  checked={operators.dentist}
                  onChange={handleChange}
                />
              }
            />
          </FormGroup>
        </Box>

        <Box sx={{ mt: 1 }}>
          <PackageFinder
            value={value}
            setValue={setValue}
            packagesDict={parseDict()}
            setPackageFormData={setPackageFormData}
            packageFormData={packageFormData}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default OperatorTabs;
